/* Credit Optimize QuickScan to $97 Credit Clarity Review - generated from uploaded co-quickscan.js */
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
// SAFE PURCHASE TRACKING - only fires when URL has ?paid=1
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var isPaid = params.get("paid") === "1";

    if (!isPaid) return;

    var key = "co_purchase_tracked_v1";
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");

    // ✅ GA PURCHASE
    if (typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: "co_" + Date.now(),
        value: 97,
        currency: "USD",
        items: [
          {
            item_name: "Credit Optimize Credit Clarity Review",
            price: 97,
            quantity: 1
          }
        ]
      });
    }

    // ✅ PINTEREST PURCHASE (this is what we’re adding)
    if (typeof window.pintrk === "function") {
      window.pintrk("track", "checkout", {
        value: 97,
        currency: "USD",
        order_quantity: 1
      });
    }

    // Optional extra event
    if (typeof window.gtag === "function") {
      window.gtag("event", "paid_review_accessed", {
        event_category: "conversion",
        event_label: "stripe_success_to_review_booking"
      });
    }

  } catch (e) {
    console.warn("Purchase tracking error:", e);
  }
})();

    var root = document.getElementById("coQuickScanApp");
    if (!root) return;

    var PLAN_URL = "https://buy.stripe.com/00wbJ0gRzcRFgwqdxzgw003";
    var STORAGE_KEY = "co_quickscan_call_payload";
    // SECURITY NOTE:
    // Do not expose an Omnisend API key in frontend JS.
    // Replace this with your Vercel endpoint that adds the contact server-side.
    // Example: "https://your-vercel-project.vercel.app/api/omnisend"
    var LEAD_CAPTURE_URL = "https://project-fhpyx.vercel.app/api/omni-capture";

    var screens = Array.prototype.slice.call(root.querySelectorAll(".co-screen"));
    var historyStack = [];
    var analysisTimers = [];
    var trackedFunnelEvents = {};

    var state = {
      step: "landing",
      q1: "",
      q2: "",
      firstName: "",
      email: "",
      headlineKey: "",
      result: null,
      emailSubmitted: false,
      emailSubmitting: false
    };

    var Q1_OPTIONS = [
      {
        value: "score_dropped_after_paying",
        title: "My score dropped after I paid balances"
      },
      {
        value: "score_dropped_for_no_reason",
        title: "My score dropped and I'm not sure why"
      },
      {
        value: "new_negative_item",
        title: "I saw a new negative item"
      },
      {
        value: "not_sure",
        title: "I'm not sure what changed"
      }
    ];

    var Q2_OPTIONS = [
      {
        value: "paid_down_balances",
        title: "I paid down my balances"
      },
      {
        value: "opened_new_account",
        title: "Opened new credit"
      },
      {
        value: "card_closed_or_limit_changed",
        title: "Card closed or limit changed"
      },
      {
        value: "nothing_changed",
        title: "Nothing changed (that I know of)"
      }
    ];

    function $(id) {
      return document.getElementById(id);
    }

    function escapeHtml(str) {
      return String(str == null ? "" : str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function getParams() {
      return new URLSearchParams(window.location.search);
    }

    function cleanKey(str) {
      return String(str || "")
        .trim()
        .replace(/^\?+|\?+$/g, "")
        .replace(/[_]+/g, "-")
        .replace(/\s+/g, "-")
        .toLowerCase();
    }

    function titleCaseFromSlug(slug) {
      return String(slug || "")
        .replace(/-/g, " ")
        .replace(/\b\w/g, function (m) { return m.toUpperCase(); });
    }

    function clearAnalysisTimers() {
      while (analysisTimers.length) {
        clearTimeout(analysisTimers.pop());
      }
    }

    function fireGA4(eventName, params) {
      try {
        if (typeof window.gtag === "function") {
          var payload = params || {};
          if (payload.debug_mode == null) payload.debug_mode = true;
          if (!payload.page_location) payload.page_location = window.location.href;
          if (!payload.page_path) payload.page_path = window.location.pathname + window.location.search;
          window.gtag("event", eventName, payload);
        }
      } catch (e) {}
    }

    function firePinterestLead(email, firstName) {
      try {
        if (typeof window.pintrk === "function") {
          window.pintrk("track", "lead", {
            lead_type: "QuickScan",
            email: email || "",
            first_name: firstName || ""
          });
        }
      } catch (e) {}
    }


    function trackingContext(extra) {
      var ctx = {
        event_category: "quickscan_funnel",
        funnel: "quickscan_to_credit_clarity_review",
        step: state.step || "",
        q1: state.q1 || "",
        q2: state.q2 || "",
        headline_key: state.headlineKey || "default",
        primary_issue: state.result && state.result.primary ? state.result.primary.key : "",
        health_score: state.result ? state.result.healthScore : ""
      };

      extra = extra || {};
      Object.keys(extra).forEach(function (key) {
        ctx[key] = extra[key];
      });

      return ctx;
    }

    function trackFunnelEvent(eventName, extra, onceKey) {
      try {
        if (onceKey && trackedFunnelEvents[onceKey]) return;
        if (onceKey) trackedFunnelEvents[onceKey] = true;
        fireGA4(eventName, trackingContext(extra || {}));
      } catch (e) {}
    }

function firePinterestCheckoutClick() {
  try {
    if (typeof window.pintrk === "function") {
      window.pintrk("track", "addtocart", {
        value: 97,
        order_quantity: 1,
        currency: "USD"
      });
    }
  } catch (e) {}
}
    function applyLandingCopy() {
      /* =========================================================
         PAID TRAFFIC LANDING COPY
         Goal: make the landing page feel like the missing explanation,
         not a soft generic credit page.

         h= controls the visible headline.
         utm_content still controls ad tracking.
         ========================================================= */

      var headlineMap = {
        // Older / original hooks
        "score-dropped-nothing-changed": "Your Score Dropped — But The Reason Isn’t Obvious?",
        "your-score-dropped-nothing-changed": "Your Score Dropped — But The Reason Isn’t Obvious?",
        "cards-paid-to-zero-score-dropped": "Paid Your Cards — Score Still Dropped??",
        "paid-to-zero-score-dropped": "Paid Your Cards — Score Still Dropped??",
        "paid-on-time-score-dropped": "Paid On Time — Score Still Dropped??",
        "paid-every-month-score-dropped": "Paid Every Month — Score Still Dropped??",
        "statement-date-vs-due-date": "Statement Date vs Due Date — This Is Where Scores Get Confusing",
        "before-due-date-still-dropped": "Paid Early — Score Still Dropped??",
        "before-statement-still-dropped": "Paid Before Statement — Score Still Dropped??",

        // New paid-ad hooks using h= full headline phrases
        "my-score-dropped-and-i-didnt-miss-a-payment": "My Score Dropped — I Didn’t Miss A Payment??",
        "i-paid-my-cards-and-my-score-went-down": "Paid Your Cards — Score Went Down??",
        "nothing-changed-but-my-score-dropped-anyway": "Your Score Dropped — But The Reason Isn’t Obvious?",
        "this-happens-right-after-you-pay-off-cards": "Paid Your Cards — This Can Still Happen",
        "one-small-change-can-drop-your-score-fast": "One Small Change — Score Dropped Fast??",
        "you-did-everything-right-but-your-score-still-dropped": "You Checked Everything — But Your Score Still Dropped?",
        "this-is-why-your-score-just-dropped": "This Is Why Your Score Just Dropped",

        // Shorter Canva-style hooks
        "paid-off-my-card-score-dropped-why": "Paid Off A Card — Score Dropped??",
        "paid-my-card-score-dropped-why": "Paid A Card — Score Dropped??",
        "paid-your-cards-score-dropped": "Paid Your Cards — Score Dropped??",
        "your-score-dropped-but-nothing-changed": "Your Score Dropped — But The Reason Isn’t Obvious?",
        "did-everything-right-why-did-my-score-drop": "You Checked Everything — But Your Score Still Dropped?",
        "did-everything-right-score-still-dropped": "You Checked Everything — But Your Score Still Dropped?",
        "one-small-change-this-dropped-my-score": "One Small Change — Score Dropped??",
        "small-change-big-drop": "One Small Change — Big Score Drop??"
      };

      var subtitleMap = {
        "score-dropped-nothing-changed": "Something changed — even if nothing looked different at first.",
        "your-score-dropped-nothing-changed": "Something changed — even if nothing looked different at first.",
        "cards-paid-to-zero-score-dropped": "Paying down balances does not always mean the lower balance was the one reported.",
        "paid-to-zero-score-dropped": "Paying down balances does not always mean the lower balance was the one reported.",
        "paid-on-time-score-dropped": "On-time payments matter — but timing, balances, and reporting can still confuse the score.",
        "paid-every-month-score-dropped": "On-time payments matter — but timing, balances, and reporting can still confuse the score.",
        "statement-date-vs-due-date": "Most people mix up due date, statement date, and reporting date — and fix the wrong thing first.",
        "before-due-date-still-dropped": "Paying early does not always mean the lower balance was reported yet.",
        "before-statement-still-dropped": "Timing can confuse even careful cardholders. This scan helps spot the biggest clue first.",

        "my-score-dropped-and-i-didnt-miss-a-payment": "This is what most people miss — the score can react even when payments were on time.",
        "i-paid-my-cards-and-my-score-went-down": "This usually comes down to what got reported — not just what you paid.",
        "nothing-changed-but-my-score-dropped-anyway": "Something changed — even if nothing looked different at first.",
        "this-happens-right-after-you-pay-off-cards": "The score may be reacting to the reporting snapshot, not the payment itself.",
        "one-small-change-can-drop-your-score-fast": "One small reporting change can create a bigger reaction than people expect.",
        "you-did-everything-right-but-your-score-still-dropped": "Something changed — even if nothing looked different at first.",
        "this-is-why-your-score-just-dropped": "Most drops follow a pattern — this scan helps spot the strongest clue first.",

        "paid-off-my-card-score-dropped-why": "This usually comes down to timing, balance snapshots, or what reported next.",
        "paid-my-card-score-dropped-why": "This usually comes down to timing, balance snapshots, or what reported next.",
        "paid-your-cards-score-dropped": "This usually comes down to timing, balance snapshots, or what reported next.",
        "your-score-dropped-but-nothing-changed": "Something changed — even if nothing looked different at first.",
        "did-everything-right-why-did-my-score-drop": "Something changed — even if nothing looked different at first.",
        "did-everything-right-score-still-dropped": "Something changed — even if nothing looked different at first.",
        "one-small-change-this-dropped-my-score": "One small reporting change can create a bigger reaction than people expect.",
        "small-change-big-drop": "One small reporting change can create a bigger reaction than people expect."
      };

      var defaultHeadline = "Your Score Dropped — But The Reason Isn’t Obvious?";
      var defaultSubtitle = "Something changed — even if nothing looked different at first.";

      var p = getParams();
      var key = cleanKey(p.get("h") || p.get("H") || p.get("headline") || p.get("Headline") || "");
      state.headlineKey = key || "";

      if ($("coHeadline")) {
        $("coHeadline").textContent = headlineMap[key] || titleCaseFromSlug(key) || defaultHeadline;
      }

      if ($("coSubtitle")) {
        $("coSubtitle").textContent = subtitleMap[key] || defaultSubtitle;
      }

      if ($("coContinueBtn")) {
        $("coContinueBtn").textContent = "Find What Changed →";
      }

      var heroCard = document.querySelector(".co-heroCard");
      if (heroCard && !heroCard.querySelector(".co-landingSignalLine")) {
        var subtitleEl = $("coSubtitle");
        var signalLine = document.createElement("div");
        signalLine.className = "co-landingSignalLine";
        signalLine.textContent = "Give us 30 seconds — we’ll help you see what may have changed.";
        if (subtitleEl && subtitleEl.parentNode) {
          subtitleEl.parentNode.insertBefore(signalLine, subtitleEl.nextSibling);
        }
      }

      if (heroCard && !heroCard.querySelector(".co-entryTrust")) {
        var trust = document.createElement("div");
        trust.className = "co-entryTrust";
        trust.textContent = "Takes 30 seconds • No SSN • No DOB";
        var btnRow = heroCard.querySelector(".co-btnRow");
        if (btnRow) btnRow.appendChild(trust);
      }
    }

    function stepConfig(step) {
      var map = {
        landing: { screen: 0, text: "Start", pct: 0, back: false },
        q1: { screen: 1, text: "Step 1", pct: 22, back: true },
        q2: { screen: 2, text: "Step 2", pct: 50, back: true },
        email: { screen: 2, text: "Next", pct: 66, back: true },
        analysis: { screen: 3, text: "Checking", pct: 76, back: false },
        signal: { screen: 4, text: "Signal", pct: 92, back: false },
        reveal: { screen: 4, text: "Unlock", pct: 100, back: false }
      };
      return map[step] || map.landing;
    }

    function showScreenByStep(step, preserveHistory) {
      state.step = step;
      var conf = stepConfig(step);

      // Keep the early QuickScan pages light/white.
      // Only the cinematic analysis and locked result screens should use dark SaaS mode.
      if (step === "analysis" || step === "signal" || step === "reveal") {
        root.classList.add("is-analysis-mode");
      } else {
        root.classList.remove("is-analysis-mode");
      }

      screens.forEach(function (screen) {
        var n = parseInt(screen.getAttribute("data-screen"), 10);
        screen.classList.toggle("active", n === conf.screen);
      });

      if ($("coStepText")) $("coStepText").textContent = conf.text;
      if ($("coProgressFill")) $("coProgressFill").style.width = conf.pct + "%";

      if ($("coBackBtn")) {
        if (conf.back) $("coBackBtn").classList.add("is-on");
        else $("coBackBtn").classList.remove("is-on");
      }

      var viewEventMap = {
        landing: "quickscan_landing_view",
        q1: "quickscan_q1_view",
        q2: "quickscan_q2_view",
        email: "quickscan_email_view",
        analysis: "quickscan_diagnostic_view",
        signal: "quickscan_result_view",
        reveal: "quickscan_review_offer_view"
      };

      if (viewEventMap[step]) {
        trackFunnelEvent(viewEventMap[step], {
          step_name: step,
          step_number: conf.screen
        }, "view_" + step);
      }

      if (!preserveHistory) {
        if (!historyStack.length || historyStack[historyStack.length - 1] !== step) {
          historyStack.push(step);
        }
      }

      setViewportMode();
      window.scrollTo(0, 0);
    }

    function goBack() {
      clearAnalysisTimers();
      if (historyStack.length <= 1) return;

      historyStack.pop();
      var prev = historyStack[historyStack.length - 1] || "landing";

      if (prev === "landing") { showScreenByStep("landing", true); return; }
      if (prev === "q1") { renderQ1(); showScreenByStep("q1", true); return; }
      if (prev === "q2") { renderQ2(); showScreenByStep("q2", true); return; }
      if (prev === "email") { renderEmailStep(); showScreenByStep("email", true); return; }
      if (prev === "signal") { renderSignalScreen(); showScreenByStep("signal", true); return; }
      if (prev === "reveal") { renderReveal(); showScreenByStep("reveal", true); return; }
    }

    function setViewportMode() {
      var w = window.innerWidth || document.documentElement.clientWidth || 0;
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      var isMobile = w <= 767;
      var isSmallPhone = w <= 430;
      var isShortViewport = h <= 760;

      root.classList.toggle("is-mobile-ui", isMobile);
      root.classList.toggle("is-small-phone-ui", isSmallPhone);
      root.classList.toggle("is-short-ui", isShortViewport);
      root.setAttribute("data-ui-mode", isMobile ? "mobile" : "desktop");
      root.setAttribute("data-ui-width", String(w));
      root.setAttribute("data-ui-height", String(h));
    }

    function bindViewportMode() {
      setViewportMode();
      window.addEventListener("resize", setViewportMode);
      window.addEventListener("orientationchange", function () {
        setTimeout(setViewportMode, 80);
      });
    }

    function getScreenBody(screenId) {
      var screen = $(screenId);
      if (!screen) return null;

      var existing = screen.querySelector(".co-dynamicMount");
      if (existing) return existing;

      var mount = document.createElement("div");
      mount.className = "co-wrap co-dynamicMount";
      screen.innerHTML = "";
      screen.appendChild(mount);
      return mount;
    }

    function buildOptionMarkup(qKey, options) {
      return options.map(function (opt) {
        var isSelected = state[qKey] === opt.value;
        return (
          '<button type="button" class="co-option' + (isSelected ? " selected" : "") + '" data-q="' + qKey + '" data-a="' + escapeHtml(opt.value) + '">' +
            '<span class="co-optionTitle">' + escapeHtml(opt.title) + '</span>' +
          '</button>'
        );
      }).join("");
    }
       function renderQ1() {
      var mount = getScreenBody("coScreen1");
      if (!mount) return;

      mount.innerHTML =
        '<div class="co-panel co-whiteAppScreen">' +
          '<div class="co-flowBackShell"><button type="button" class="co-inlineBack" data-back="1">← Back</button></div>' +
          '<div class="co-stepTitle">Step 1 — understanding what changed</div>' +
          '<h2 class="co-qtitle">What happened to your score?</h2>' +
          '<p class="co-toolHelper">Choose the closest match — we’ll narrow it down</p>' +
          '<div class="co-options co-options--question">' +
            buildOptionMarkup("q1", Q1_OPTIONS) +
          '</div>' +
        '</div>';
    }

    function renderQ2() {
      var mount = getScreenBody("coScreen2");
      if (!mount) return;

      mount.innerHTML =
        '<div class="co-panel co-whiteAppScreen">' +
          '<div class="co-flowBackShell"><button type="button" class="co-inlineBack" data-back="1">← Back</button></div>' +
          '<div class="co-stepTitle">Final step — almost there</div>' +
          '<h2 class="co-qtitle">What changed right before the drop?</h2>' +
          '<p class="co-toolHelper">This is usually where the trigger comes from</p>' +
          '<div class="co-microProgressLine">Narrowing this down now</div>' +
          '<div class="co-options co-options--question">' +
            buildOptionMarkup("q2", Q2_OPTIONS) +
          '</div>' +
        '</div>';
    }

    function renderEmailStep() {
      var mount = getScreenBody("coScreen2");
      if (!mount) return;

      mount.innerHTML =
        '<div class="co-panel co-panelEmail co-whiteAppScreen">' +
          '<div class="co-flowBackShell"><button type="button" class="co-inlineBack" data-back="1">← Back</button></div>' +
          '<div class="co-stepTitle">Almost there</div>' +
          '<h2 class="co-qtitle">We’re preparing your results</h2>' +
          '<p class="co-qsub">Enter your email so you don’t lose your scan</p>' +
          '<div class="co-emailMicroLine">Your signal check is almost ready</div>' +
          '<div class="co-emailCard">' +
            '<div class="co-emailForm" id="coLeadFormWrap">' +
              '<input id="coFirstNameInput" class="co-emailInput" type="text" inputmode="text" autocomplete="given-name" placeholder="First name" value="' + escapeHtml(state.firstName || "") + '">' +
              '<input id="coEmailInput" class="co-emailInput" type="email" inputmode="email" autocomplete="email" placeholder="Email address" value="' + escapeHtml(state.email || "") + '">' +
              '<div class="co-emailError" id="coEmailError" style="display:none;"></div>' +
              '<div class="co-btnRow">' +
                '<button type="button" class="co-btn" id="coEmailContinueBtn">View My Results →</button>' +
              '</div>' +
              '<div class="co-emailTrust">No SSN • No DOB • No account linking</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function issueToneClass(tone) {
      if (tone === "red") return "is-danger";
      if (tone === "orange") return "is-watch";
      return "is-good";
    }

    function toneWeight(tone) {
      if (tone === "red") return 3;
      if (tone === "orange") return 2;
      return 1;
    }

    function signalDotClass(level) {
      if (level === "red" || level === "flagged") return "is-red";
      if (level === "green" || level === "stable") return "is-green";
      if (level === "blue" || level === "neutral") return "is-blue";
      return "is-orange";
    }

    function dedupeSignals(signals) {
      var seen = {};
      return signals.filter(function (signal) {
        if (!signal || !signal.label) return false;
        if (seen[signal.label]) return false;
        seen[signal.label] = true;
        return true;
      });
    }

    function buildQuickSignals() {
      var bucket = getPrimarySignalBucket ? getPrimarySignalBucket() : "unknown";
      var signals = [];

      function push(label, status, level) {
        signals.push({ label: label, status: status, level: level || "neutral" });
      }

      if (bucket === "timing") {
        push("Recent changes reviewed", "Checked", "green");
        push("Balance/utilization pressure", "Possible factor", "orange");
        push("Reporting timing mismatch", "Needs review", "red");
        push("Hidden negative pressure", "Not fully checked", "blue");
      } else if (bucket === "utilization") {
        push("Recent changes reviewed", "Checked", "green");
        push("Balance/utilization pressure", "Needs review", "red");
        push("Reporting timing mismatch", "Possible factor", "orange");
        push("Hidden negative pressure", "Not fully checked", "blue");
      } else if (bucket === "negative") {
        push("Recent changes", "Possible factor", "orange");
        push("Balance/utilization pressure", "Not fully checked", "blue");
        push("Reporting timing mismatch", "Not fully checked", "blue");
        push("Negative pressure signal", "Needs review", "red");
      } else if (bucket === "credit_change") {
        push("Recent credit change", "Needs review", "red");
        push("Balance/utilization pressure", "Possible factor", "orange");
        push("Reporting timing mismatch", "Possible factor", "orange");
        push("Hidden negative pressure", "Not fully checked", "blue");
      } else {
        push("Recent changes", "Possible factor", "orange");
        push("Balance/utilization pressure", "Possible factor", "orange");
        push("Reporting timing mismatch", "Possible factor", "orange");
        push("Hidden negative pressure", "Not fully checked", "blue");
      }

      return signals.slice(0, 4);
    }

    function getSignalHeadline(signals) {
      return "We detected a signal that may be affecting your score";
    }

    function getSignalInsight(signals) {
      var labels = signals.map(function (s) { return s.label; }).join("|");

      if (labels.indexOf("negative") >= 0 || labels.indexOf("Negative") >= 0) {
        return "Even one negative or reporting shift can trigger reactions from lenders and affect your score more than expected.";
      }

      if (labels.indexOf("Available credit") >= 0 || labels.indexOf("credit change") >= 0 || labels.indexOf("Recent credit") >= 0) {
        return "Even one change — like a card closure, limit change, or new account — can increase pressure on your score.";
      }

      if (labels.indexOf("reporting timing") >= 0 || labels.indexOf("utilization") >= 0) {
        return "Even one change — like reporting timing or a balance shift — can trigger reactions from lenders and affect your score more than expected.";
      }

      return "Even one change can trigger reactions from lenders and affect your score more than expected.";
    }

    function deriveIssues() {
      var issues = [
        { key: "balances", label: "Balances", tone: "green", score: 18 },
        { key: "timing", label: "Reporting timing", tone: "green", score: 18 },
        { key: "negative", label: "Negative activity", tone: "green", score: 16 },
        { key: "credit_change", label: "Recent credit changes", tone: "green", score: 16 }
      ];

      function raise(key, tone, points) {
        for (var i = 0; i < issues.length; i++) {
          if (issues[i].key === key) {
            if (toneWeight(tone) > toneWeight(issues[i].tone)) issues[i].tone = tone;
            issues[i].score += points || 0;
          }
        }
      }

      if (state.q1 === "score_dropped_after_paying") {
        raise("balances", "red", 34);
        raise("timing", "orange", 20);
      }

      if (state.q1 === "score_dropped_for_no_reason") {
        raise("timing", "orange", 22);
        raise("negative", "orange", 12);
      }

      if (state.q1 === "new_negative_item") {
        raise("negative", "red", 40);
        raise("credit_change", "orange", 10);
      }

      if (state.q1 === "not_sure") {
        raise("timing", "orange", 14);
        raise("negative", "orange", 12);
      }

      if (state.q2 === "paid_down_balances") {
        raise("balances", "red", 18);
        raise("timing", "orange", 16);
      }

      if (state.q2 === "opened_new_account") {
        raise("credit_change", "red", 24);
        raise("timing", "orange", 8);
      }

      if (state.q2 === "card_closed_or_limit_changed") {
        raise("credit_change", "red", 28);
        raise("balances", "orange", 12);
      }

      if (state.q2 === "nothing_changed") {
        raise("timing", "orange", 10);
        raise("negative", "orange", 10);
      }

      issues.sort(function (a, b) {
        if (toneWeight(b.tone) !== toneWeight(a.tone)) return toneWeight(b.tone) - toneWeight(a.tone);
        return b.score - a.score;
      });

      var primary = issues[0];
      var secondary = issues[1];

      var healthScore = 81;
      if (primary.tone === "red") healthScore = 58;
      else if (primary.tone === "orange") healthScore = 68;

      if (secondary && secondary.tone === "red") healthScore -= 6;
      if (secondary && secondary.tone === "orange") healthScore -= 3;

      if (healthScore < 48) healthScore = 48;
      if (healthScore > 88) healthScore = 88;

      state.result = {
        issues: issues,
        primary: primary,
        secondary: secondary,
        healthScore: healthScore,
        primaryLabel: primary.label
      };
    }

    function getPrimaryIssueCopy() {
      if (!state.result || !state.result.primary) {
        return {
          title: "We found what your score may be reacting to",
          resultLine: "A hidden balance, timing issue, or negative detail may be affecting your score."
        };
      }

      var key = state.result.primary.key;

      if (key === "balances") {
        return {
          title: "We found what your score may be reacting to",
          resultLine: "Your score may be reacting to how your balances showed up."
        };
      }

      if (key === "timing") {
        return {
          title: "We found what your score may be reacting to",
          resultLine: "Your score may be reacting to when your cards reported."
        };
      }

      if (key === "negative") {
        return {
          title: "We found what your score may be reacting to",
          resultLine: "A negative item or hidden issue may be affecting your score."
        };
      }

      if (key === "credit_change") {
        return {
          title: "We found what your score may be reacting to",
          resultLine: "A recent credit change may be affecting your score."
        };
      }

      return {
        title: "We found what your score may be reacting to",
        resultLine: "A hidden balance, timing issue, or negative detail may be affecting your score."
      };
    }

    function buildPayload() {
      return {
        v: 21,
        ts: Date.now(),
        source: "quickscan_to_credit_clarity_review_v1",
        headlineKey: state.headlineKey || "",
        q1: state.q1 || "",
        q2: state.q2 || "",
        firstName: state.firstName || "",
        email: state.email || "",
        primaryIssue: state.result && state.result.primary ? state.result.primary.label : "",
        primaryKey: state.result && state.result.primary ? state.result.primary.key : "",
        healthScore: state.result ? state.result.healthScore : "",
        issues: state.result ? state.result.issues : [],
        emailSubmitted: !!state.emailSubmitted
      };
    }

    function savePayload() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(buildPayload()));
      } catch (e) {}
    }

    function buildPlanUrl() {
      return PLAN_URL;
    }

    function analysisLines() {
      return [
        "Reviewing recent changes",
        "Checking balance patterns",
        "Comparing reporting timing",
        "Scanning for hidden pressure",
        "Preparing your signal profile"
      ];
    }

    function animateCountUp(id, target, duration) {
      var el = $(id);
      if (!el) return;

      var startTime = null;
      target = Number(target || 0);
      duration = duration || 1000;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased);

        if (progress < 1) window.requestAnimationFrame(step);
        else el.textContent = target;
      }

      window.requestAnimationFrame(step);
    }
     
    function updateLandingPreviewCopy() {
      try {
        var preview = document.querySelector(".co-previewMini");
        if (!preview) return;

        var label = preview.querySelector(".co-miniLabel");
        if (label) label.textContent = "Credit clarity preview";

        var num = preview.querySelector(".co-miniIndexNum");
        if (num) {
          num.style.display = "none";
        }

        var sub = preview.querySelector(".co-miniIndexSub");
        if (sub) {
          sub.textContent = "Reviewing your answer pattern…";
        }

        var signals = Array.prototype.slice.call(preview.querySelectorAll(".co-miniSignalText"));
        var tags = Array.prototype.slice.call(preview.querySelectorAll(".co-miniSignalTag"));
        var copy = [
          "Reviewing recent balance changes",
          "Checking reporting timing",
          "Looking for hidden factors"
        ];

        signals.forEach(function (el, i) {
          if (copy[i]) el.textContent = copy[i];
        });

        tags.forEach(function (el) {
          el.textContent = "";
          el.style.display = "none";
        });
      } catch (e) {}
    }

    function animateLandingPreview() {
      var indexEl = document.querySelector(".co-screen.active .co-miniIndexNum") || document.querySelector(".co-miniIndexNum");
      var barEl = document.querySelector(".co-screen.active .co-miniBar span") || document.querySelector(".co-miniBar span");
      var signalEls = document.querySelectorAll(".co-screen.active .co-miniSignal, .co-miniSignals .co-miniSignal");

      if (!indexEl || !barEl || !signalEls.length) return;
      if (indexEl.dataset.animated === "true") return;

      indexEl.dataset.animated = "true";

      var target = 58;
      var duration = 950;
      var startTime = null;

      indexEl.textContent = "0";
      barEl.style.width = "0%";

      signalEls.forEach(function (el) {
        el.style.opacity = "0";
        el.style.transform = "translateY(8px)";
        el.style.transition = "opacity .35s ease, transform .35s ease";
      });

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);

        indexEl.textContent = Math.round(target * eased);
        barEl.style.width = (62 * eased) + "%";

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          indexEl.textContent = String(target);
          barEl.style.width = "62%";

          signalEls.forEach(function (el, i) {
            setTimeout(function () {
              el.style.opacity = "1";
              el.style.transform = "translateY(0)";
            }, 90 * i);
          });
        }
      }

      window.requestAnimationFrame(step);
    }

    function validEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
    }

    function buildLeadTags() {
      var q1TagMap = {
        score_dropped_after_paying: "CO - Score Dropped After Paying",
        score_dropped_for_no_reason: "CO - Score Dropped No Clear Reason",
        new_negative_item: "CO - New Negative Item",
        not_sure: "CO - Not Sure What Changed"
      };

      var q2TagMap = {
        paid_down_balances: "CO - Paid Down Balances",
        opened_new_account: "CO - Opened New Account",
        card_closed_or_limit_changed: "CO - Card Closed Or Limit Changed",
        nothing_changed: "CO - Nothing Changed"
      };

      var issueTagMap = {
        balances: "CO - Signal Balances",
        timing: "CO - Signal Reporting Timing",
        negative: "CO - Signal Negative Activity",
        credit_change: "CO - Signal Credit Change"
      };

      var tags = ["Credit Optimize", "QuickScan", "CO - QuickScan Lead"];

      if (state.q1 && q1TagMap[state.q1]) tags.push(q1TagMap[state.q1]);
      if (state.q2 && q2TagMap[state.q2]) tags.push(q2TagMap[state.q2]);

      if (state.result && state.result.primary && state.result.primary.key && issueTagMap[state.result.primary.key]) {
        tags.push(issueTagMap[state.result.primary.key]);
      }

      var clean = [];
      var seen = {};
      tags.forEach(function (tag) {
        tag = String(tag || "").trim();
        if (!tag || seen[tag]) return;
        seen[tag] = true;
        clean.push(tag);
      });

      return clean;
    }

    
    function getPrimarySignalBucket() {
      if (state.q1 === "new_negative_item") return "negative";
      if (state.q2 === "card_closed_or_limit_changed") return "credit_change";
      if (state.q2 === "opened_new_account") return "credit_change";
      if (state.q1 === "score_dropped_after_paying" && state.q2 === "paid_down_balances") return "timing";
      if (state.q1 === "score_dropped_after_paying") return "timing";
      if (state.q2 === "paid_down_balances") return "utilization";
      if (state.q1 === "score_dropped_for_no_reason" || state.q1 === "not_sure" || state.q2 === "nothing_changed") return "unknown";
      return "unknown";
    }

    function getDynamicAnalysisRows() {
      var bucket = getPrimarySignalBucket();

      var rows = [
        { key: "recent", label: "Reviewing recent changes", level: "stable", status: "Checked" },
        { key: "balance", label: "Checking balance patterns", level: "neutral", status: "Not fully checked" },
        { key: "timing", label: "Comparing reporting timing", level: "neutral", status: "Not fully checked" },
        { key: "pressure", label: "Scanning for hidden pressure", level: "neutral", status: "Not fully checked" },
        { key: "profile", label: "Finalizing signal profile", level: "active", status: "In progress" }
      ];

      function setRow(key, level, status) {
        rows.forEach(function (row) {
          if (row.key === key) {
            row.level = level;
            row.status = status;
          }
        });
      }

      if (bucket === "timing") {
        setRow("timing", "flagged", "Needs review");
        setRow("balance", "possible", "Contributing");
        setRow("recent", "stable", "Checked");
      }

      if (bucket === "utilization") {
        setRow("balance", "flagged", "Needs review");
        setRow("timing", "possible", "Contributing");
        setRow("recent", "stable", "Checked");
      }

      if (bucket === "negative") {
        setRow("pressure", "flagged", "Needs review");
        setRow("recent", "possible", "Contributing");
        setRow("timing", "neutral", "Not fully checked");
      }

      if (bucket === "credit_change") {
        setRow("recent", "flagged", "Needs review");
        setRow("balance", "possible", "Contributing");
        setRow("timing", "possible", "Contributing");
      }

      if (bucket === "unknown") {
        setRow("recent", "possible", "Contributing");
        setRow("balance", "possible", "Contributing");
        setRow("timing", "possible", "Contributing");
        setRow("pressure", "neutral", "Not fully checked");
      }

      setRow("profile", "active", "In progress");

      return rows;
    }

    function analysisIconFor(level) {
      if (level === "flagged") return "×";
      if (level === "possible") return "!";
      if (level === "stable") return "✓";
      if (level === "active") return "•";
      return "•";
    }

    function analysisStatusLabel(level, fallback) {
      if (level === "flagged") return "Flagged";
      if (level === "possible") return "Possible factor";
      if (level === "stable") return "Checked";
      if (level === "active") return "In progress";
      return fallback || "Not fully checked";
    }

    function getAnalysisCompletionTitle() {
      var bucket = getPrimarySignalBucket();
      if (bucket === "timing") return "A reporting timing issue is showing up";
      if (bucket === "utilization") return "Balance pressure is showing up";
      if (bucket === "negative") return "A negative signal is showing up";
      if (bucket === "credit_change") return "A credit change is showing up";
      return "One signal is showing up";
    }

    function getAnalysisCompletionSubline() {
      return "This scan shows the signal — not the full cause.";
    }

function renderAnalysis() {
      var mount = getScreenBody("coScreen3");
      if (!mount) return;

      var rows = getDynamicAnalysisRows();

      root.classList.add("is-analysis-mode");

      mount.innerHTML =
        '<div class="co-processingCard co-processingCard--dark co-darkSystemScreen">' +
          '<div class="co-flowBackShell co-flowBackShell--dark"><button type="button" class="co-inlineBack co-inlineBack--dark" data-back="1">← Back</button></div>' +
          '<div class="co-stepTitle co-stepTitle--dark">Signal check in progress</div>' +
          '<h2 class="co-qtitle co-qtitle--dark">We’re identifying what’s affecting your score</h2>' +
          '<div class="co-analysisMeterWrap">' +
            '<div class="co-analysisMeter"><span id="coAnalysisMeterFill"></span></div>' +
            '<div class="co-analysisMeterText" id="coAnalysisMeterText">Starting signal check...</div>' +
          '</div>' +
          '<div class="co-analysisStack co-analysisStack--flat co-analysisStack--dynamic" id="coAnalysisStack">' +
            rows.map(function (row, idx) {
              return (
                '<div class="co-analysisRow co-analysisRow--flat co-analysisRow--dynamic co-analysisLevel-' + row.level + '" id="coAnalysisRow' + idx + '" data-final-level="' + escapeHtml(row.level) + '" data-final-status="' + escapeHtml(row.status) + '">' +
                  '<span class="co-analysisDot co-analysisDot--dynamic">' + escapeHtml(analysisIconFor(row.level)) + '</span>' +
                  '<span class="co-analysisText co-analysisText--dark">' + escapeHtml(row.label) + '</span>' +
                  '<span class="co-analysisChip" id="coAnalysisChip' + idx + '">Waiting</span>' +
                '</div>'
              );
            }).join('') +
          '</div>' +
          '<div class="co-analysisInlineCta" id="coAnalysisInlineCta" style="display:block; opacity:0; transform:translateY(10px); max-height:0; overflow:hidden; pointer-events:none; transition:opacity .42s ease, transform .42s ease, max-height .42s ease; margin-top:18px;">' +
            '<div class="co-analysisDoneTitle co-analysisDoneTitle--dark">' + escapeHtml(getAnalysisCompletionTitle()) + '</div>' +
            '<div class="co-analysisDoneSub co-analysisDoneSub--dark">' + escapeHtml(getAnalysisCompletionSubline()) + '</div>' +
            '<div class="co-analysisPowerLine">Most people miss this and fix the wrong thing first.</div>' +
            '<div class="co-btnRow" style="margin-top:14px;">' +
              '<button type="button" class="co-btn" id="coAnalysisContinue" disabled>View My Review Option →</button>' +
            '</div>' +
            '<div class="co-miniTrust co-miniTrust--dark">No SSN. No DOB. Educational analysis only.</div>' +
          '</div>' +
        '</div>';
    }

    function activateAnalysisRow(idx) {
      var row = $("coAnalysisRow" + idx);
      var chip = $("coAnalysisChip" + idx);
      var meterFill = $("coAnalysisMeterFill");
      var meterText = $("coAnalysisMeterText");
      var lines = analysisLines();

      if (!row) return;

      row.classList.add("co-active");
      if (chip) chip.textContent = "Checking";
      if (meterFill) {
        meterFill.style.width = Math.min(92, Math.round(((idx + 1) / lines.length) * 100) - 8) + "%";
      }
      if (meterText) meterText.textContent = lines[idx] + "...";
    }

    function completeAnalysisRow(idx) {
      var row = $("coAnalysisRow" + idx);
      var chip = $("coAnalysisChip" + idx);

      if (!row) return;

      row.classList.remove("co-active");
      row.classList.add("done");
      var finalStatus = row.getAttribute("data-final-status") || "Checked";
      if (chip) chip.textContent = finalStatus;
    }


    
function runAnalysisAnimation() {
      var rows = Array.prototype.slice.call(root.querySelectorAll(".co-analysisRow--dynamic"));
      var meter = $("coAnalysisMeterFill");
      var meterText = $("coAnalysisMeterText");
      var cta = $("coAnalysisInlineCta");
      var continueBtn = $("coAnalysisContinue");

      if (!rows.length) return;

      rows.forEach(function (row, idx) {
        var chip = row.querySelector(".co-analysisChip");
        row.classList.remove("done", "co-active", "is-resolved");
        if (chip) chip.textContent = "Waiting";
      });

      rows.forEach(function (row, idx) {
        setTimeout(function () {
          var chip = row.querySelector(".co-analysisChip");
          rows.forEach(function (r) { r.classList.remove("co-active"); });
          row.classList.add("co-active");
          if (chip) chip.textContent = "Checking";
          if (meterText) meterText.textContent = row.querySelector(".co-analysisText") ? row.querySelector(".co-analysisText").textContent + "..." : "Checking...";
          if (meter) meter.style.width = Math.max(14, Math.round(((idx + 0.45) / rows.length) * 100)) + "%";
        }, idx * 520);

        setTimeout(function () {
          var chip = row.querySelector(".co-analysisChip");
          var finalStatus = row.getAttribute("data-final-status") || "Checked";
          row.classList.remove("co-active");
          row.classList.add("done", "is-resolved");
          if (chip) chip.textContent = finalStatus;
          if (meter) meter.style.width = Math.round(((idx + 1) / rows.length) * 100) + "%";
        }, idx * 520 + 390);
      });

      setTimeout(function () {
        if (meterText) meterText.textContent = "One signal is standing out...";
      }, rows.length * 520 + 180);

      setTimeout(function () {
        if (cta) {
          cta.style.opacity = "1";
          cta.style.transform = "translateY(0)";
          cta.style.maxHeight = "260px";
          cta.style.pointerEvents = "auto";
        }
        if (continueBtn) continueBtn.disabled = false;
        if (meterText) meterText.textContent = "Your result is ready";
      }, rows.length * 520 + 620);
    }
function renderSignalScreen() {
      if (!state.result) deriveIssues();

      var mount = getScreenBody("coScreen4");
      if (!mount) return;

      var signals = buildQuickSignals();

      root.classList.add("is-analysis-mode");

      mount.innerHTML =
        '<div class="co-signalPanel co-signalPanel--dark co-darkSystemScreen">' +
          '<div class="co-flowBackShell co-flowBackShell--dark"><button type="button" class="co-inlineBack co-inlineBack--dark" data-back="1">← Back</button></div>' +
          '<div class="co-stepTitle co-stepTitle--dark">Signal detected</div>' +
          '<h2 class="co-signalTitle">You’re seeing the signal — not what’s causing it</h2>' +
          '<p class="co-signalPainLine">Your score can keep reacting — even when you’re doing the “right” things.</p>' +
          '<p class="co-signalSub">Your answers point to something affecting your score — but the full trigger still needs review.</p>' +

          '<div class="co-signalTableLabel">Signal detected</div>' +
          '<div class="co-signalTable">' +
            signals.map(function (signal, idx) {
              return (
                '<div class="co-signalItem co-signalRow--delay' + idx + '">' +
                  '<div class="co-signalItemLeft">' +
                    '<span class="co-signalDot ' + signalDotClass(signal.level) + '"></span>' +
                    '<span class="co-signalName">' + escapeHtml(signal.label) + '</span>' +
                  '</div>' +
                  '<div class="co-signalStatus co-signalStatus--' + escapeHtml(signalDotClass(signal.level).replace("is-", "")) + '">' + escapeHtml(signal.status) + '</div>' +
                '</div>'
              );
            }).join('') +
          '</div>' +

          '<div class="co-signalTightBlock">' +
            '<div>A private review can help clarify what is impacting your score — and what to check first.</div>' +
          '</div>' +

          '<div class="co-btnRow">' +
            '<button type="button" class="co-btn co-signalContinueBtn" id="coSignalContinueBtn">Book My Credit Clarity Review — $97 →</button>' +
          '</div>' +

          '<div class="co-resultTrust">15–20 min private review • No SSN • No passwords</div>' +
        '</div>';

      savePayload();
      trackFunnelEvent("quickscan_signal_viewed", { step_number: 5 }, "signal_viewed");

      setTimeout(function () {
        var rows = mount.querySelectorAll(".co-signalItem");
        Array.prototype.forEach.call(rows, function (row, idx) {
          setTimeout(function () {
            row.classList.add("is-visible");
          }, 120 + (idx * 120));
        });
      }, 50);
    }
    function buildPreviewDashboard() {
      var result = state.result;
      var scoreWidth = Math.max(10, Math.min(100, result.healthScore));

      return (
        '<div class="co-previewShell">' +
          '<div class="co-previewHeader">' +
            '<div class="co-previewBadge">Review preview</div>' +
            '<h3 class="co-previewTitle">Your review focuses on</h3>' +
            '<p class="co-previewSub">The likely signal, what to check first, and what may be affecting your score.</p>' +
          '</div>' +
          '<div class="co-dashboardPreviewFrame">' +
            '<div class="co-dashboardPreviewBlur"></div>' +
            '<div class="co-dashHero">' +
              '<div class="co-dashHeroLeft">' +
                '<div class="co-dashMiniLabel">Trigger detected</div>' +
                '<div class="co-dashIndexRow">' +
                  '<div class="co-dashIndexNumber" id="coDashIndexNumber" data-target="' + escapeHtml(String(result.healthScore)) + '">0</div>' +
                  '<div class="co-dashIndexMeta">Primary factor</div>' +
                '</div>' +
                '<div class="co-dashIndexBar"><span style="width:' + scoreWidth + '%"></span></div>' +
              '</div>' +
              '<div class="co-dashHeroRight">' +
                '<div class="co-dashStatusPill ' + issueToneClass(result.primary.tone) + '">' + escapeHtml(result.primary.label) + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="co-previewGrid">' +
              '<div class="co-lockCard">' +
                '<div class="co-lockLabel">Review</div>' +
                '<div class="co-lockHint">What may be impacting it</div>' +
                '<div class="co-previewLine"></div><div class="co-previewLine is-short"></div>' +
              '</div>' +
              '<div class="co-lockCard">' +
                '<div class="co-lockLabel">Review</div>' +
                '<div class="co-lockHint">What to do first</div>' +
                '<div class="co-previewLine"></div><div class="co-previewLine is-short"></div>' +
              '</div>' +
            '</div>' +
            '<div class="co-lockOverlay">Review available</div>' +
          '</div>' +
        '</div>'
      );
    }
function renderReveal() {
      if (!state.result) deriveIssues();

      var mount = getScreenBody("coScreen4");
      if (!mount) return;

      var signals = buildQuickSignals();

      root.classList.add("is-analysis-mode");

      mount.innerHTML =
        '<div class="co-panelResult co-panelResult--dark co-resultClean co-resultMerged">' +
          '<div class="co-flowBackShell co-flowBackShell--dark"><button type="button" class="co-inlineBack co-inlineBack--dark" data-back="1">← Back</button></div>' +

          '<div class="co-resultHero co-resultHero--merged">' +
            '<div class="co-stepTitle co-stepTitle--dark">Credit clarity review</div>' +
            '<h2 class="co-resultMainTitle co-resultMainTitle--merged">Your review option is ready</h2>' +
            '<p class="co-resultPainLine co-resultPainLine--merged">Your answers show a signal worth checking before you make another move.</p>' +
            '<p class="co-resultHeroSub co-resultHeroSub--merged">This is not a full credit review yet — it is a quick snapshot showing what may need a closer look.</p>' +
          '</div>' +

          '<div class="co-resultTrustStrip">' +
            '<div><strong>5,000+</strong><span>credit reports reviewed</span></div>' +
            '<div><strong>No SSN</strong><span>no passwords needed</span></div>' +
            '<div><strong>15–20 min</strong><span>private review</span></div>' +
          '</div>' +

          '<div class="co-resultSoftLinks">' +
            '<a href="https://creditoptimizehub.com/pages/about-credit-optimize">Why Credit Optimize is different</a>' +
            '<span>•</span>' +
            '<a href="https://creditoptimizehub.com/pages/free-checklist">Free Credit Clarity Checklist</a>' +
          '</div>' +

          '<div class="co-resultSignalBlock">' +
            '<div class="co-signalTableLabel">What the QuickScan noticed</div>' +
            '<div class="co-signalTable co-signalTable--merged">' +
              signals.map(function (signal, idx) {
                return (
                  '<div class="co-signalItem is-visible co-signalRow--delay' + idx + '">' +
                    '<div class="co-signalItemLeft">' +
                      '<span class="co-signalDot ' + signalDotClass(signal.level) + '"></span>' +
                      '<span class="co-signalName">' + escapeHtml(signal.label) + '</span>' +
                    '</div>' +
                    '<div class="co-signalStatus co-signalStatus--' + escapeHtml(signalDotClass(signal.level).replace("is-", "")) + '">' + escapeHtml(signal.status) + '</div>' +
                  '</div>'
                );
              }).join('') +
            '</div>' +
          '</div>' +

          '<div class="co-resultCleanGrid co-resultCleanGrid--merged">' +
            '<div class="co-resultCleanLeft">' +
              '<div class="co-resultValueBlock">' +
                '<div class="co-resultValueLabel">A private review helps clarify:</div>' +
                '<ul class="co-resultBullets">' +
                  '<li>what is actually impacting your score</li>' +
                  '<li>what to check first</li>' +
                  '<li>what matters right now</li>' +
                  '<li>what to avoid before making another move</li>' +
                '</ul>' +
              '</div>' +
            '</div>' +

            '<div class="co-resultPurchaseBlock">' +
              '<div class="co-resultUrgency">Without clarity, it is easy to focus on the wrong issue while your score keeps reacting.</div>' +
              '<div class="co-resultMiniLine">A private review can help you understand what to check first.</div>' +
              '<div class="co-resultCredLine">Trusted by mortgage professionals across the United States.</div>' +
              '<div class="co-resultPriceLabel">Private review</div>' +
              '<div class="co-resultPrice">$97</div>' +
              '<button type="button" class="co-btn co-resultUnlockBtn" id="coUnlockBtn">Book My Credit Clarity Review — $97 →</button>' +
              '<div class="co-resultTrust">Schedule after payment • No SSN • No passwords</div>' +
            '</div>' +
          '</div>' +

          '<div class="co-stickyUnlock">' +
            '<div class="co-stickyUnlockInner">' +
              '<div class="co-stickyPrice">' +
                '<div class="co-stickyPriceLabel">Private review</div>' +
                '<div class="co-stickyPriceValue">$97</div>' +
              '</div>' +
              '<button type="button" class="co-btn" id="coUnlockBtnSticky">Book My Credit Clarity Review — $97 →</button>' +
            '</div>' +
          '</div>' +
        '</div>';

      savePayload();
      trackFunnelEvent("quickscan_review_offer_viewed", { step_number: 6 }, "paywall_viewed");
    }

function runAnalysisSequence() {
      clearAnalysisTimers();

      var lines = analysisLines();
      var baseDelay = 240;
      var stepDelay = root.classList.contains("is-small-phone-ui") ? 980 : 1160;

      lines.forEach(function (_, idx) {
        analysisTimers.push(setTimeout(function () {
          activateAnalysisRow(idx);
        }, baseDelay + (idx * stepDelay)));

        analysisTimers.push(setTimeout(function () {
          completeAnalysisRow(idx);
        }, baseDelay + (idx * stepDelay) + 650));
      });

      analysisTimers.push(setTimeout(function () {
        var cta = $("coAnalysisInlineCta");
        var btn = $("coAnalysisContinue");
        var meterFill = $("coAnalysisMeterFill");
        var meterText = $("coAnalysisMeterText");

        if (meterFill) meterFill.style.width = "100%";
        if (meterText) meterText.textContent = "Finalizing your signal profile...";

        deriveIssues();

        if (cta) {
          cta.classList.add("is-visible");
          cta.style.opacity = "1";
          cta.style.transform = "translateY(0)";
          cta.style.maxHeight = "220px";
          cta.style.pointerEvents = "auto";
        }

        if (btn) {
          setTimeout(function () {
            btn.disabled = false;
          }, 420);
        }
      }, baseDelay + (lines.length * stepDelay) + 140));
    }

    function submitLeadEmail(firstName, email) {
      return new Promise(function (resolve, reject) {
        if (!validEmail(email)) {
          reject(new Error("Enter a valid email to continue."));
          return;
        }

        if (!state.result) deriveIssues();

        var tags = buildLeadTags();

        var quickScanPayload = buildPayload();

        var payload = {
          email: email,
          firstName: firstName || "",
          status: "subscribed",
          statusDate: new Date().toISOString(),
          tags: tags,
          sendWelcomeEmail: false,

          // Top-level fields for Omnisend tagging/segmentation in Vercel.
          source: "free_quickscan",
          q1: state.q1 || "",
          q2: state.q2 || "",
          headlineKey: state.headlineKey || "",
          primaryIssue: state.result && state.result.primary ? state.result.primary.label : "",
          primaryKey: state.result && state.result.primary ? state.result.primary.key : "",
          healthScore: state.result ? state.result.healthScore : "",

          // Full local scan payload for backend customProperties if you choose to store it.
          quickScan: quickScanPayload
        };

        if (!LEAD_CAPTURE_URL) {
          console.warn("QuickScan: LEAD_CAPTURE_URL is blank. Lead was stored locally only. Add your Vercel endpoint before launch.");
          resolve(true);
          return;
        }

        var xhr = new XMLHttpRequest();
        xhr.open("POST", LEAD_CAPTURE_URL, true);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
          if (xhr.status < 500) {
            resolve(true);
          } else {
            reject(new Error("Email could not be saved right now."));
          }
        };

        xhr.onerror = function () {
          console.warn("QuickScan: lead endpoint network error — continuing funnel.");
          resolve(true);
        };

        xhr.send(JSON.stringify(payload));
      });
    }

    
    function showMicroReaction(message, done) {
      // Silent transition only. No floating helper/toast text.
      setTimeout(function () {
        if (typeof done === "function") done();
      }, 180);
    }

function proceedAfterQ2() {
      proceedToAnalysis();
    }

    function proceedAfterEmail() {
      proceedToAnalysis();
    }

    function proceedToAnalysis() {
      deriveIssues();
      renderAnalysis();
      showScreenByStep("analysis", false);
      trackFunnelEvent("quickscan_analysis_started", { step_number: 4 }, "analysis_started");
      runAnalysisSequence();
    }

    function handleOptionClick(btn) {
      var q = btn.getAttribute("data-q");
      var a = btn.getAttribute("data-a");
      if (!q || !a) return;

      var currentWrap = btn.parentNode;
      if (currentWrap) {
        Array.prototype.forEach.call(currentWrap.querySelectorAll(".co-option"), function (node) {
          node.classList.remove("selected");
        });
      }

      btn.classList.add("selected");
      state[q] = a;

      if (q === "q1") {
        trackFunnelEvent("quickscan_q1_answer", { answer: a, step_number: 1 });
        trackFunnelEvent("quickscan_q1_answered", { answer: a, step_number: 1 });
        showMicroReaction("Signal path started — narrowing it down.", function () {
          renderQ2();
          showScreenByStep("q2", false);
        });
        return;
      }

      if (q === "q2") {
        trackFunnelEvent("quickscan_q2_answer", { answer: a, step_number: 2 });
        trackFunnelEvent("quickscan_q2_answered", { answer: a, step_number: 2 });
        showMicroReaction("Pattern noted — preparing signal check.", function () {
          proceedAfterQ2();
        });
      }
    }

    function handleEmailSubmit() {
      if (state.emailSubmitting) return;

      var nameInput = $("coFirstNameInput");
      var emailInput = $("coEmailInput");
      var err = $("coEmailError");
      var btn = $("coEmailContinueBtn");

      var firstNameVal = nameInput ? String(nameInput.value || "").trim() : "";
      var emailVal = emailInput ? String(emailInput.value || "").trim() : "";

      if (!firstNameVal) {
        if (err) {
          err.style.display = "block";
          err.textContent = "Please enter your first name.";
        }
        if (nameInput) nameInput.focus();
        return;
      }

      if (!validEmail(emailVal)) {
        if (err) {
          err.style.display = "block";
          err.textContent = "Enter a valid email to continue.";
        }
        if (emailInput) emailInput.focus();
        return;
      }

      if (!state.result) deriveIssues();

      trackFunnelEvent("quickscan_email_submit_attempt", { step_number: 3 });

      state.firstName = firstNameVal;
      state.email = emailVal;
      state.emailSubmitting = true;
      savePayload();

      if (err) {
        err.style.display = "none";
        err.textContent = "";
      }

      if (btn) {
        btn.disabled = true;
        btn.textContent = "Saving...";
      }

      submitLeadEmail(firstNameVal, emailVal).then(function () {
        state.emailSubmitted = true;
        state.emailSubmitting = false;
        savePayload();

        firePinterestLead(emailVal, firstNameVal);

        trackFunnelEvent("quickscan_email_submit", {
          step_number: 3,
          email_domain: (emailVal.split("@")[1] || "").toLowerCase()
        });

        trackFunnelEvent("quickscan_email_captured", {
          step_number: 3,
          first_name: firstNameVal,
          email_domain: (emailVal.split("@")[1] || "").toLowerCase()
        });

        proceedAfterEmail();
      }).catch(function (error) {
        state.emailSubmitting = false;

        if (btn) {
          btn.disabled = false;
          btn.textContent = "View My Results →";
        }

        if (err) {
          err.style.display = "block";
          err.textContent = error && error.message ? error.message : "Something went wrong. Please try again.";
        }
      });
    }

    function goToPlan() {
      savePayload();

      trackFunnelEvent("quickscan_review_offer_click", {
        step_number: 7,
        primary_issue: state.result && state.result.primary ? state.result.primary.key : "unknown",
        health_score: state.result ? state.result.healthScore : 0
      });

      trackFunnelEvent("quickscan_review_booking_clicked", {
        step_number: 7,
        primary_issue: state.result && state.result.primary ? state.result.primary.key : "unknown",
        health_score: state.result ? state.result.healthScore : 0
      });
      firePinterestCheckoutClick();

      window.location.href = buildPlanUrl();
    }

    function bindEvents() {
      if ($("coContinueBtn")) {
        $("coContinueBtn").addEventListener("click", function () {
          trackFunnelEvent("quickscan_start", { step_number: 0 }, "scan_started_standard");
          trackFunnelEvent("quickscan_started", { step_number: 0 }, "scan_started");

          renderQ1();
          showScreenByStep("q1", false);
        });
      }

      if ($("coBackBtn")) {
        $("coBackBtn").addEventListener("click", goBack);
      }

      root.addEventListener("click", function (e) {
        var backBtn = e.target.closest(".co-inlineBack");
        if (backBtn && root.contains(backBtn)) {
          goBack();
          return;
        }

        var optionBtn = e.target.closest(".co-option");
        if (optionBtn && root.contains(optionBtn)) {
          handleOptionClick(optionBtn);
          return;
        }

        var continueBtn = e.target.closest("#coEmailContinueBtn");
        if (continueBtn) {
          handleEmailSubmit();
          return;
        }

        var analysisContinueBtn = e.target.closest("#coAnalysisContinue");
        if (analysisContinueBtn) {
          renderReveal();
          showScreenByStep("reveal", false);
          return;
        }

        var signalContinueBtn = e.target.closest("#coSignalContinueBtn");
        if (signalContinueBtn) {
          renderReveal();
          showScreenByStep("reveal", false);
          return;
        }

        var unlockBtn = e.target.closest("#coUnlockBtn");
        if (unlockBtn) {
          goToPlan();
          return;
        }

        var unlockBtnSticky = e.target.closest("#coUnlockBtnSticky");
        if (unlockBtnSticky) {
          goToPlan();
          return;
        }
      });

      root.addEventListener("keydown", function (e) {
        if (
          e.target &&
          (e.target.id === "coEmailInput" || e.target.id === "coFirstNameInput") &&
          e.key === "Enter"
        ) {
          e.preventDefault();
          handleEmailSubmit();
        }
      });
    }

    function hydrateFromStorage() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;

        var saved = JSON.parse(raw);
        if (!saved || typeof saved !== "object") return;

        if (saved.firstName) state.firstName = saved.firstName;
        if (saved.email) state.email = saved.email;
        if (saved.emailSubmitted) state.emailSubmitted = true;
      } catch (e) {}
    }

    hydrateFromStorage();
    applyLandingCopy();
    updateLandingPreviewCopy();
    bindViewportMode();
    bindEvents();
    historyStack = ["landing"];
    showScreenByStep("landing", true);
    trackFunnelEvent("quickscan_landing_view", { step_number: 0 }, "landing_view");
    animateLandingPreview();
  });
})();